import { initialState, ManagersState } from './selectors';
import * as actions from './actions';

export default (
  state: ManagersState = initialState,
  action: actions.ManagersAction,
) => {
  switch (action.type) {
    case actions.MANAGERS_ACTIONS.REQUESTED: {
      return { ...state, loading: true };
    }

    case actions.MANAGERS_ACTIONS.SUCCEEDED: {
      const {
        payload: { managers },
      } = action as actions.ManagersSucceeded;

      return { ...state, managers, loading: false };
    }

    case actions.REMOVE_MANAGER_ACTIONS.REQUESTED: {
      return { ...state, loading: true };
    }

    case actions.REMOVE_MANAGER_ACTIONS.SUCCEEDED: {
      const {
        payload: { managerId },
      } = action as actions.RemoveManagerSucceeded;

      const managers = state.managers.filter(
        manager => manager.id.toString() !== managerId.toString(),
      );

      return { ...state, managers, loading: false };
    }

    case actions.CREATE_MANAGER_ACTIONS.REQUESTED: {
      return { ...state, loading: true };
    }

    case actions.CREATE_MANAGER_ACTIONS.SUCCEEDED: {
      const {
        payload: { manager },
      } = action as actions.CreateManagerSucceeded;

      const managers = state.managers.filter(
        item => item.id.toString() !== manager.id.toString(),
      );

      return {
        ...state,
        loading: false,
        managers: [manager, ...managers],
      };
    }

    case actions.EDIT_MANAGER_ACTIONS.SUCCEEDED: {
      const {
        payload: { manager },
      } = action as actions.EditManagerSucceeded;

      const managers = state.managers.filter(
        item => item.id.toString() !== manager.id.toString(),
      );

      return { ...state, managers: [manager, ...managers] };
    }

    case actions.SET_EDIT_MANAGER_ACTIONS.SELECT: {
      const {
        payload: { manager },
      } = action as any;

      return { ...state, editManager: manager };
    }

    case actions.SET_EDIT_MANAGER_ACTIONS.REMOVE: {
      return { ...state, editManager: initialState.editManager };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/scenes/Managers/services/reducer.ts